import { ISettingsModel } from "./tile-toolbar/tile-toolbar.component";

export const defaultNodeSettings: ISettingsModel = {
  updateTime: "60"
};
